// extracted by mini-css-extract-plugin
export default {"container":"BottomLead_container__5hgE1","text":"BottomLead_text__mMXj1"};